import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CompaniesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Companies",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.01 2.96H5.37A3.38 3.38 0 0 0 2 6.34v21.24c0 .8.65 1.45 1.45 1.45h4.28V24.2c0-.54.44-.99.99-.99h2.96c.54 0 .99.44.99.99v4.82h4.32c.8 0 1.45-.65 1.45-1.45V6.35c0-1.87-1.52-3.38-3.38-3.38h-.04Zm-.48 4.82H5.86c-.54 0-.99-.44-.99-.99s.44-.99.99-.99h8.69c.54 0 .99.44.99.99s-.44.99-.99.99zm.99 3.86c0 .54-.44.99-.99.99H5.86c-.54 0-.99-.44-.99-.99s.44-.99.99-.99h8.69c.54.01.97.45.97.99m-9.66 5.8c-.54 0-.99-.44-.99-.99s.44-.99.99-.99h8.69c.54 0 .99.44.99.99s-.44.99-.99.99zm20.77-4.82h-4.84c-.79 0-1.43.63-1.45 1.41v13.52c0 .8.65 1.45 1.45 1.45h6.76c.8 0 1.45-.65 1.45-1.45V16.01c0-1.87-1.51-3.38-3.37-3.38Zm-.48 9.66h-1.97c-.54 0-.99-.44-.99-.99s.44-.99.99-.99h1.97c.54 0 .99.44.99.99s-.44.99-.99.99m0-4.82h-1.97c-.54 0-.99-.44-.99-.99s.44-.99.99-.99h1.97c.54 0 .99.44.99.99s-.44.99-.99.99"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.48 27.71c-.63 0-1.14-.51-1.14-1.14V7.14h-9.2v19.43a1.14 1.14 0 1 1-2.28 0V6c0-.63.51-1.14 1.14-1.14h11.48c.63 0 1.14.51 1.14 1.14v20.57c0 .63-.51 1.14-1.14 1.14M28.14 27.71c-.63 0-1.14-.51-1.14-1.14v-9.04l-4.95-3.3-2.41 1.61c-.52.35-1.23.21-1.58-.32s-.21-1.23.32-1.58l3.05-2.03c.38-.26.88-.26 1.27 0l6.1 4.06c.32.21.51.57.51.95v9.65c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.86 11.71H7.57a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 1 0 2.28M9.86 16.29H7.57a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 1 0 2.28M9.86 20.86H7.57a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
CompaniesIcon.displayName = 'CompaniesIcon';